import { render } from "./checkoutComponent.vue?vue&type=template&id=2b305213&scoped=true"
import script from "./checkoutComponent.vue?vue&type=script&lang=js"
export * from "./checkoutComponent.vue?vue&type=script&lang=js"

import "./checkoutComponent.vue?vue&type=style&index=0&id=2b305213&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b305213"]])

export default __exports__